import React from "react";
import { Container } from "reactstrap";

import { LeftSidebarPortal, XCircleLoader } from "components";
import { WizardIntro } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardIntro";
import { WizardFormWrapper } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardFormWrapper";
import { WizardLeftSidebar } from "objs/_ConfiguratorObjs/Wizard/WizardLeftSidebar/WizardLeftSidebar";
import { WizardLeftSidebarExtension } from "objs/_ConfiguratorObjs/Wizard/WizardLeftSidebar/Extension/WizardLeftSidebarExtension";
import {
  useCurrentQuestionnaire,
  useIsFetching,
  useIsMultipleQuestionnaireListStep,
  useIsTopology,
  useWizardStep,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import { WizardResult } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardResult";

export const WizardMainWrapper = () => {
  const wizardStep = useWizardStep();
  const isTopology = useIsTopology();
  const currentQuestionnaire = useCurrentQuestionnaire();
  const isMultipleQuestionnaireListStep = useIsMultipleQuestionnaireListStep();
  const isFetching = useIsFetching();

  return (
    <>
      <div className="position-relative h-full overflow-scroll overflow-x-hidden">
        {(isFetching && isTopology) ?? <XCircleLoader classNames="h-100" />}
        {!isTopology && (
          <Container className="px-0">
            {wizardStep === 0 && <WizardIntro />}
            {currentQuestionnaire && wizardStep !== 0 && !isTopology && (
              <WizardFormWrapper />
            )}
          </Container>
        )}
        {isTopology && <WizardResult />}
      </div>
      <LeftSidebarPortal>
        <WizardLeftSidebar />
        {(isTopology || isMultipleQuestionnaireListStep) &&
          wizardStep !== 0 && <WizardLeftSidebarExtension />}
      </LeftSidebarPortal>
    </>
  );
};
